import * as actions from './actions'

export const state = {
  sum: 0
}

const mutations = {
  add (state) {
    state.sum += 1
  },
  sub (state) {
    state.sum -= 1
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/counter/index.js